export default "__VITE_ASSET__BByO7dd2__"